import {
  ADD_FILTER,
  ADD_MULTI_SELECT,
  TOGGLE_SLIDE_LEAVE,
  TOGGLE_SLIDE_STATUS,
  EXPLORE_OPTION,
} from '../constants/action-types';

function rootReducer(state, action) {
  switch (action.type) {
    case ADD_FILTER:
      const newFilter = action.payload.value;
      return {
        ...state,
        ...{ [action.payload.results_key]: newFilter },
      };

    case ADD_MULTI_SELECT:
      return {
        ...state,
        ...{ [action.payload.results_key]: action.payload.value },
      };

    case TOGGLE_SLIDE_STATUS:
      const index = action.payload;
      return {
        ...state,
        slideStatus: {
          ...state.slideStatus,
          ...{ [index]: { completed: true } },
        },
      };

    case EXPLORE_OPTION:
      let slideGroup = {};

      for (let i = 1; i < 5; i++) {
        slideGroup = { ...slideGroup, ...{ [i]: { completed: true } } };
      }
      return {
        ...state,
        slideStatus: {
          ...state.slideStatus,
          ...slideGroup,
        },
      };

    case TOGGLE_SLIDE_LEAVE:
      return {
        ...state,
        ...{ sliderDisabled: !state.sliderDisabled },
      };
    default:
      return state;
  }
}

export default rootReducer;
